// Preserve a destination across sign-in and registration, including email links opened in
// another tab: the organization page (invitations, settings) or an app's connection request.
// Store no token or account data; a destination is an in-app path.
const key = 'unity-organization-return';
const pathKey = 'unity-authentication-return';
const HOUR = 60 * 60 * 1000;
const inAppPath = (path: unknown): path is string =>
    typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');

export function rememberOrganizationReturn() {
    try { localStorage.setItem(key, String(Date.now() + HOUR)); } catch { /* Storage is optional. */ }
}
/** Return to this in-app path (and its query) after signing in, within the hour. */
export function rememberAuthenticationReturn(path: string) {
    if (!inAppPath(path)) return;
    try { localStorage.setItem(pathKey, JSON.stringify({ path, until: Date.now() + HOUR })); } catch { /* Storage is optional. */ }
}
function rememberedPath(): string | null {
    try {
        const value = JSON.parse(localStorage.getItem(pathKey) || 'null');
        return value && value.until > Date.now() && inAppPath(value.path) ? value.path : null;
    } catch { return null; }
}
function organizationPending() {
    try { return Number(localStorage.getItem(key)) > Date.now(); } catch { return false; }
}
/** A destination is waiting: sign-in goes there instead of the home page or checkout. */
export function hasAuthenticationReturn() {
    return organizationPending() || rememberedPath() !== null;
}
export function consumeAuthenticationReturn(fallback = '/Unity') {
    const path = rememberedPath();
    const organization = organizationPending();
    try { localStorage.removeItem(key); localStorage.removeItem(pathKey); } catch { /* Storage is optional. */ }
    return path ?? (organization ? '/organization' : fallback);
}
